module abc from "abc";

export var value = abc;